export default __webpack_public_path__ + "static/media/icn-distance.54d73534.svg";